/* Stylesheet */

.cohort {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: var(--ion-color-text-primary);

  .fab_button {
    height: 28px;
    width: 28px;
    --background: transparent;
    --box-shadow: none;

    .icon {
      height: 16px;
      width: 16px;
      color: var(--ion-color-dark-primary);
    }
  }

  .name {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 0.875rem;

    .icon {
      margin: 0px 12px 0px 0px;
      height: 16px;
      width: 16px;
    }
  }
}
